<template>
    <b-form-group class="mb-0 w-100">
        <vue-autosuggest
            ref="autocomplete"
            :suggestions="suggestions"
            :input-props="inputProps"
            :get-suggestion-value="getSuggestionValue"
            @selected="onSuggestionSelect"
            @input="fetchResults"
        >
            <div slot-scope="{suggestion}">
                <div>
                    <div class="pb-1">
                        <b-badge variant="success" class="mr-1" v-if="showSelectedBadge && isSelected(suggestion)">
                            selected
                        </b-badge>
                        <b-badge class="mr-1">{{ suggestion.item.vatNumber }}</b-badge>
                        <strong>{{suggestion.item.title}}</strong>
                    </div>
                    <div>
                        <div v-if="suggestion.item.contact">
                            <div>
                                <strong>Contact:</strong> {{ suggestion.item.contact.name }}
                            </div>
                            <div>
                                <strong>{{ $t('Enum(CommunicationType):email') }}:</strong> {{ suggestion.item.contact.email }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-autosuggest>
    </b-form-group>
</template>

<script>
import {
    BFormGroup, BBadge,
} from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'
import { SupplyChain } from "@core/api";

export default {
    components: {
        VueAutosuggest,
        BFormGroup,
        BBadge
    },

    props: {
        isSupplierSelectedCallback: {},
        placeholder: {
            default() {
                return this.$t('Component(SupplierSelector):search-placeholder');
            }
        },
        showSelectedBadge: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            suggestions: [],
            inputProps: {
                id: 'autosuggest_supplier_input_ajax',
                placeholder: this.placeholder,
                class: 'form-control w-100',
                name: 'ajax',
            },
            searchTimer: null,
        };
    },

    methods: {
        getSuggestionValue() {
            return '';
        },
        onSuggestionSelect(suggestion) {
            this.$emit('selected', suggestion.item)
        },
        fetchResults(qs) {
            if (!qs) {
                return;
            }
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                SupplyChain.searchSupplier(qs).then((r) => {
                    this.suggestions = [{data: r.data}];
                });
            }, 600);
        },

        isSelected(suggestion) {
            if (this.isSupplierSelectedCallback) {
                return this.isSupplierSelectedCallback(suggestion);
            }
            return false;
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';

.autosuggest__results-item {
    cursor: pointer;
}
</style>
